import React from "react";
import modalStyles from "@/styles/Modal.module.scss";
import { Button } from "../Buttons";
import { useCallback, useEffect, useState, useRef, forwardRef } from "react";
import routes from "@/lib/routes";

const ChatMessageReportStepMute = (props) => {
  const addMutedUser = useCallback(() => {
    props.addMutedUser(props.userId);
    props.modalCloseHandle();
  }, [props]);
  const addMutedMessage = useCallback(() => {
    props.addMutedMessage(props.id);
    props.modalCloseHandle();
  }, [props]);
  return (
    <>
      <header>
        <h3>非表示内容</h3>
      </header>
      <div className={modalStyles.chatMessageDisplay}>
        <div className={modalStyles.chatMessage}>
          <span className={modalStyles.username}>{props.displayName}</span>
          <span className={modalStyles.messageContent}>{props.postDesc}</span>
        </div>
      </div>
      <Button
        key="addMutedMessageButton"
        borderLight
        fontFixed
        fillWhiteColor
        large
        onClick={addMutedMessage}
      >
        このコメントのみ非表示
      </Button>
      <Button
        key="addMutedUserButton"
        borderLight
        fontFixed
        fillWhiteColor
        large
        onClick={addMutedUser}
      >
        このユーザーのコメントを非表示
      </Button>
      <Button fontFixed large borderLight onClick={props.modalCloseHandle}>
        閉じる
      </Button>
    </>
  );
};

export default ChatMessageReportStepMute;
